export const FIRST_MET_NUMBER = /^\d+|\d+\b|\d+(?=\w)/g;
export const FIRST_MET_STRING_BETWEEN_DITTO_MARKS = /"[^"]*"/;
export const FIRST_MET_NUMBER_OR_FIRST_MET_STRING_BETWEEN_DITTO_MARKS = new RegExp(
  `(?:${FIRST_MET_STRING_BETWEEN_DITTO_MARKS.source}|${FIRST_MET_NUMBER.source})`
);
export const FIRST_MET_SQUARE_BRACKETS = /(?:\[[^\[]*\])/;
export const EMAIL =
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const LINE_BREAK = /(\r\n|\n|\r)/gm;
export const COMMA_WITH_OR_WITHOUT_SPACE = /,\s*/;
